import * as SystemRegistry from '../registry/system_registry.js?v=20260904f';

/**
 * Core-Objekte sind zeichnungsnahe Sicht-/Deko-/Rack-Objekte, aber keine
 * Core-Gruppen. Sie erscheinen separat in der Objektkarte.
 */
function getCoreObjects() {
  return SystemRegistry.collectCoreObjects()
    .map(normalizeCoreObject)
    .filter(Boolean);
}

function normalizeCoreObject(rawObject) {
  if (!rawObject || typeof rawObject !== 'object') return null;
  const systemId = String(rawObject.systemId || rawObject.systemKey || '').trim();
  const objectId = String(rawObject.objectId || rawObject.id || rawObject.primaryId || '').trim();
  if (!systemId || !objectId) return null;
  const objectType = String(rawObject.objectType || rawObject.type || rawObject.kind || 'object').trim() || 'object';
  const key = String(rawObject.key || `${systemId}:${objectType}:${objectId}`).trim();
  return {
    ...rawObject,
    id: rawObject.id || objectId,
    objectId,
    objectType,
    key,
    systemId,
    systemKey: systemId,
    displayName: rawObject.displayName || rawObject.label || rawObject.name || objectId,
    label: rawObject.label || rawObject.displayName || rawObject.name || objectId,
    productLabel: rawObject.productLabel || systemId,
    visible: rawObject.visible !== false && rawObject.hidden !== true,
    raw: rawObject.raw || rawObject
  };
}

export {
  getCoreObjects,
  normalizeCoreObject
};
